import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ShareImageToSocialMedia from "core/ShareImageToSocialMedia";
import TwitterIcon from "core/jsSvgIcons/Twitter";

let ShareImageToTwitter = ({
    className,
    creatorName,
    imageType,
    permalinkPath,
    height,
    width,
    color
}) => (
    <ShareImageToSocialMedia
        creatorName={creatorName}
        platform="Twitter"
        imageType={imageType}
        permalinkPath={permalinkPath}
        className={className}
    >
        <TwitterIcon
            title="Twitter logo"
            size={width && height && { width, height }}
            fillColor={color}
        />
    </ShareImageToSocialMedia>
);

ShareImageToTwitter.propTypes = {
    className: PropTypes.string,
    creatorName: PropTypes.string.isRequired,
    imageType: PropTypes.oneOf(["photo", "icon"]).isRequired,
    permalinkPath: PropTypes.string.isRequired,
    height: PropTypes.number,
    width: PropTypes.number,
    color: PropTypes.string
};

ShareImageToTwitter = styled(ShareImageToTwitter)``;

export default ShareImageToTwitter;
